import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar'; // IMPORTAMOS EL MENÚ INTELIGENTE
import { useNavigate } from 'react-router-dom';
import { Home, PlusCircle } from 'lucide-react'; // Dejamos solo los iconos necesarios

const Aulas = () => {
  const navigate = useNavigate();
  const [aulas, setAulas] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  
  // Estados del formulario
  const [grado, setGrado] = useState('');
  const [seccion, setSeccion] = useState('');
  const [capacidad, setCapacidad] = useState(30);
  const [periodoId, setPeriodoId] = useState('');
  const [nivel, setNivel] = useState('Secundaria');

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    const token = localStorage.getItem('token');
    if (!token) return navigate('/login');

    try {
      const [resAulas, resPeriodos] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/Aulas`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${process.env.REACT_APP_API_URL}/Periodos`, { headers: { 'Authorization': `Bearer ${token}` } })
      ]);

      if (resAulas.ok) setAulas(await resAulas.json());
      if (resPeriodos.ok) setPeriodos(await resPeriodos.json());
    } catch (error) {
      console.error("Error cargando datos:", error);
    }
  };

  const handleGuardar = async (e) => {
    e.preventDefault();
    if(!periodoId) return alert("Debes seleccionar un Año Escolar.");

    const token = localStorage.getItem('token');
    
    const nuevaAula = { grado, seccion, nivel, capacidad: parseInt(capacidad), periodoId: parseInt(periodoId), activo: true };
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Aulas`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(nuevaAula)
      });

      if (response.ok) {
        setGrado(''); setSeccion(''); setCapacidad(30);
        cargarDatos();
        alert('¡Aula registrada con éxito!');
      }
    } catch (error) {
      console.error("Error guardando aula:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      
      {/* AQUÍ INYECTAMOS EL MENÚ INTELIGENTE */}
      <Sidebar />

      {/* ÁREA PRINCIPAL */}
      <main className="flex-1 p-6 overflow-y-auto">
        <h1 className="text-2xl font-bold text-slate-800 mb-6 flex items-center gap-2">
          <Home className="text-blue-600" /> Gestión de Aulas y Secciones
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Formulario */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 h-fit">
            <h2 className="text-lg font-medium text-slate-800 mb-4 flex items-center gap-2"><PlusCircle size={20}/> Nueva Aula</h2>
            <form onSubmit={handleGuardar} className="space-y-4">
              <div>
                <label className="block text-sm text-slate-600 mb-1">Año Escolar *</label>
                <select value={periodoId} onChange={e => setPeriodoId(e.target.value)} required className="w-full p-2 border rounded outline-none focus:ring-2 focus:ring-blue-500 bg-slate-50">
                  <option value="">-- Seleccionar --</option>
                  {periodos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm text-slate-600 mb-1">Grado *</label>
                <input type="text" required value={grado} onChange={e => setGrado(e.target.value)} className="w-full p-2 border rounded outline-none focus:ring-2 focus:ring-blue-500" placeholder="Ej. 1ro Secundaria" />
              </div>

              <div>
                <label className="block text-sm text-slate-600 mb-1">Nivel *</label>
                <select value={nivel} onChange={e => setNivel(e.target.value)} required className="w-full p-2 border rounded outline-none focus:ring-2 focus:ring-blue-500 bg-slate-50">
                  <option value="Inicial">Inicial</option>
                  <option value="Primaria">Primaria</option>
                  <option value="Secundaria">Secundaria</option>
                </select>
              </div>
              
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className="block text-sm text-slate-600 mb-1">Sección *</label>
                  <input type="text" required value={seccion} onChange={e => setSeccion(e.target.value)} className="w-full p-2 border rounded outline-none focus:ring-2 focus:ring-blue-500 text-center uppercase" placeholder="Ej. A" maxLength="2" />
                </div>
                <div>
                  <label className="block text-sm text-slate-600 mb-1">Capacidad *</label>
                  <input type="number" required min="1" value={capacidad} onChange={e => setCapacidad(e.target.value)} className="w-full p-2 border rounded outline-none focus:ring-2 focus:ring-blue-500 text-center" />
                </div>
              </div>
              <button type="submit" className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700 font-medium mt-2">Guardar Aula</button>
            </form>
          </div>

          {/* Lista de Aulas */}
          <div className="md:col-span-2 bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-slate-50 border-b text-sm text-slate-600">
                  <th className="p-4 font-medium">Grado y Sección</th>
                  <th className="p-4 font-medium">Capacidad</th>
                  <th className="p-4 font-medium">Año Escolar</th>
                </tr>
              </thead>
              <tbody>
                {aulas.map((aula) => (
                  <tr key={aula.id} className="border-b hover:bg-slate-50">
                    <td className="p-4 font-medium text-slate-800">{aula.grado} - "{aula.seccion}" ({aula.nivel})</td>
                    <td className="p-4 text-slate-600">{aula.capacidad} alumnos</td>
                    <td className="p-4 text-slate-500 text-sm">
                      {/* Buscamos el nombre del periodo para mostrarlo bonito */}
                      {periodos.find(p => p.id === aula.periodoId)?.nombre || `ID: ${aula.periodoId}`}
                    </td>
                  </tr>
                ))}
                {aulas.length === 0 && (<tr><td colSpan="3" className="p-8 text-center text-slate-500">No hay aulas registradas.</td></tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Aulas;